import script from "./ProdutoRotuloSolicitacaoForm_29.vue?vue&type=script&setup=true&lang=js"
export * from "./ProdutoRotuloSolicitacaoForm_29.vue?vue&type=script&setup=true&lang=js"

import "./ProdutoRotuloSolicitacaoForm_29.vue?vue&type=style&index=0&id=5325edb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5325edb2"]])

export default __exports__